module.exports = __webpack_public_path__ + "static/media/l-Less Than.b3b9c3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/l-Less Than.png
// module id = 167
// module chunks = 0